module.exports = __webpack_public_path__ + "img/status_4.ce3ba0de.png";